export const accordionItemStyleProps = {
  bg: 'brand.lightpink',
  color: 'brand.red',
  borderBottomWidth: '3px',
  borderColor: 'brand.red',
};
// export const inputTextStyleProps = {
//   border: '1px solid #ACABAB !important',
//   bg: '#F4F4F4',
//   borderRadius: '4px',
// };
export const menuListStylesProps = {
  bg: 'brand.red',
  color: 'brand.white',
  minW: '0',
  w: '100px',
};
export const scrollbarStyles = {
  '&::-webkit-scrollbar': {
    width: '5px',
    height: '6px',
  },
  '&::-webkit-scrollbar-track': {
    width: '8px',
  },
  '&::-webkit-scrollbar-thumb': {
    backgroundColor: '#B72618',
    borderRadius: '30px',
  },
};
export const gridStylesProps = {
  w: '265px',
  // maxH: '300px',
  borderWidth: '1px',
  spacing: '2',
  rounded: 'xl',
  roundedBottom: '0',
  borderBottomWidth: '0',
  boxShadow: 'md',
  mr: '3',
  bg: 'brand.white',
  align: 'stretch',
};
export const gridHeaderStylesProps = {
  width: 'full',
  align: 'flex-start',
  bg: 'brand.lightpink',
  p: '2',
  roundedTop: 'xl',
  color: 'brand.black',
  height: '43px',
};
export const gridBottomStylesProps = {
  bg: '#F2F2F2',
  p: '2',
  roundedBottom: 'xl',
  boxShadow: 'md',
  borderWidth: '1px',
  w: '265px',
  maxH: '100px',
  mb: '4',
};

export const tagStylesProps = {
  mr: '2',
  borderColor: '#DCDADA',
  bg: '#F8F8F8 ',
  borderWidth: '1px ',
  borderRadius: '0 ',
  p: '2 ',
  borderLeftWidth: '3px ',
  borderLeftColor: 'brand.red',
  m: '2 ',
  color: '#000',
};
